import { bindCallbacks, statusText } from 'scripts/infrastructure/backends/fake_backend_http/lib/common';

export default class StationConfigurationService {
  constructor(database, pubsub) {
    this._pubsub = pubsub;
    this.getDatabase = database;
  }

  find(compAttrs, callback, path, { orgId }) {
    let stations = this._getStations(orgId);

    callback(null, { status: 200, statusText: statusText(200), response: stations });
  }

  _getStations(orgId) {
    let database = this.getDatabase(orgId);
    let stations = database.stationConfigurations;
    return stations;
  }

  getRoutes() {
    return bindCallbacks(
      {
        '/api/v1/orgs/:orgId/telephony/configuration/stations': {
          GET: this.find,
        },
      },
      this
    );
  }
}
